/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import cloneDeep from "lodash/fp/cloneDeep";
import merge from "lodash/fp/merge";

import { MessagesPayload, MessagesState, MessagesType } from "~/features/messages/types";

const initialState: MessagesState = {
  messages: {
    data: {
      title: "",
      message: "",
      type: MessagesType.DIALOG,
    },
  },
};

const messagesSlice = createSlice({
  name: "messages",
  initialState,
  reducers: {
    resetMessage: (state) => {
      state.messages = cloneDeep(initialState.messages);
    },
    setMessage: (state, action: PayloadAction<MessagesPayload>) => {
      state.messages.data = merge(state.messages.data, action.payload);
    },
  },
});

export const MessagesActions = messagesSlice.actions;

export const messagesReducer = messagesSlice.reducer;
